import vuetify from "@/main";
import Import from './Import.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider) {
  $stateProvider.state('import', {
    url: "/import",
    ...vuetify(Import)
    // template: require('./views/import.html'),
    // controller: 'SyncImportCtrl',
  });
}]);